export default (state: IKeyValue) => ({
	// foo: state.foo,
	completedTutorial: state.completedTutorial,
});
